import { Component, Input, OnInit, OnDestroy, AfterViewChecked, OnChanges } from '@angular/core';
import { Page } from '../page';
import { PagesService } from '../../services/pages.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-page-home',
  templateUrl: './page-home.component.html',
  styleUrls: ['./page-home.component.scss'],
  providers: [PagesService]
})
export class PageHomeComponent implements OnInit /*, OnDestroy, AfterViewChecked, OnChanges */ {

  @Input() page:Page;

  constructor(private pagesService:PagesService, private route:ActivatedRoute, private router: Router) {
  }

  // getPage(slug) {
  //   this.pagesService
  //     .getPage(slug)
  //     .subscribe(res => {
  //       this.page = res[0];
  //     });
  // }

  ngOnInit() {
    // this.route.params.forEach((params:Params) => {
    //   this.page = null;
    //   this.getPage('home');
    //   console.log(params);
    // });
    this.router.navigate(['/we-are-designers']);
  }

  //ngOnDestroy() {
  //  console.log('destroy');
  //
  //}
  //
  //ngAfterViewChecked(){
  //  console.log('avc');
  //}
  //
  //ngOnChanges(){
  //  console.log('onchanges');
  //}
  //

}



// WEBPACK FOOTER //
// ./src/app/pages/page-home/page-home.component.ts